import "./index.less";

export class Controller {
	constructor() {
		this.lookup.selection = false;
	}

	$onInit() {
		this.lookup.selection = this.lookup.state;
	}

	setNotAvailable() {
		this.lookup.selection = !this.lookup.selection;
		this.onSelect({
			lookup: this.lookup
		});
	}
}

export default angular
	.module("vesl.components.field-helpers.not-available", [])
	.component("notAvailable", {
		template: `
      <button type="button"
        class="btn btn-default"
        uib-tooltip="Not Available"
        aria-label="Not Available"
        ng-disabled="$ctrl.lookup.disabled"
        ng-click="$ctrl.setNotAvailable()">
          <svg ng-class="$ctrl.lookup.selection ? 'c-red' : 'c-black'" class="not-available-icon ma-icon"
            viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" focusable="false">
            <path fill-rule="evenodd" d="M16 1a15 15 0 1 1 0 30 15 15 0 1 1 0-30Z
              M4.7 22V10h2.4l3.3 7.7V10h2.2v12h-2.4l-3.3-7.7V22Z
              M13.3 23l3.8-14h2.3l-3.8 14Z
              M18.3 22l3.8-12h2.3l3.8 12h-2.5l-.7-2.5h-3.5l-.7 2.5Z
              M22.1 17.4h2.3l-1.15-4.1Z"></path>
          </svg>
      </button>
    `,
		controller: Controller,
		bindings: {
			lookup: "<",
			onSelect: "&"
		}
	}).name;
